import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import "./SelectInput.css";

export const SelectInput = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Selecione uma opção",
  disabled = false,
  error = "",
}) => {
  return (
    <div className="selectInputWrapperCompany">
      {label && <label className="selectLabel" htmlFor={name}>{label}</label>}
      <div className="select-wrapper">
        <FormControl fullWidth error={!!error}>
          <Select
            id={name}
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            displayEmpty
            className="selectInput"
            MenuProps={{
              disablePortal: true,
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  zIndex: 9999,
                },
              },
            }}
            renderValue={(selected) => {
              if (!selected) {
                return <span className="placeholder">{placeholder}</span>;
              }
              const selectedOption = options.find((opt) => opt.value === selected);
              return <span className="selectedValue">{selectedOption?.label || selected}</span>;
            }}
          >
            <MenuItem value="">
              <em>{placeholder}</em>
            </MenuItem>
            {options.map(({ label, value }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
          {error && <p className="textError">{error}</p>}
        </FormControl>
      </div>
    </div>
  );
};

export default SelectInput;
